/**
 * Mixpanel events for the companion app banner
 * (docs/features/companion-app-banner/prd.md, W7). Names and payloads match
 * Atlas's `assistantTelemetry.ts` so both apps feed one series.
 */
import mixpanel from 'mixpanel-browser';
import type { CompanionAppsSurface } from '@/config/companionApps';

function track(eventName: string, properties: Record<string, string>): void {
  try {
    mixpanel.track(eventName, properties);
  } catch {
    // Mixpanel not initialised or blocked: a lost promo event is not worth surfacing.
  }
}

/** The banner rendered an app (the caller limits this to once per session). */
export function trackCompanionAppsViewed(surface: CompanionAppsSurface): void {
  track('companion_apps_viewed', { surface });
}

/** A merchant opened an app's App Store listing ("Set up now"). */
export function trackCompanionAppClicked(surface: CompanionAppsSurface, app: string): void {
  track('companion_app_clicked', { surface, app });
}

/** A merchant closed an app's promo with ✕. */
export function trackCompanionAppDismissed(surface: CompanionAppsSurface, app: string): void {
  track('companion_app_dismissed', { surface, app });
}
